import { C } from '../../theme.js';
import { Alert, Eyebrow } from '../../components/Primitives.jsx';
import { MultiColsDropdown } from './MultiColsDropdown.jsx';
import { hasUpstreamSplit } from '../../data.js';
import { DecimalPlacesField } from '../shared/DecimalPlacesField.jsx';
import { OutputColumnNamesField } from '../shared/OutputColumnNamesField.jsx';

/**
 * FrequencyEncodingInspector
 * Maps categories to their frequency/count ratio in the dataset.
 */
export function FrequencyEncodingInspector({ step, onChange, pipeline }) {
  const c = step.config || {};
  const sel = Array.isArray(c.columns) ? c.columns : (c.column ? [c.column] : []);
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  const splitReady = pipeline ? hasUpstreamSplit(pipeline.steps, step.id) : true;

  return (
    <div>
      <Eyebrow>Frequency Encoding</Eyebrow>
      <div style={{ color: C.fg4, fontSize: '.78rem', margin: '4px 0 10px', lineHeight: 1.5 }}>
        Replace each category with its frequency (proportion) in the dataset.
      </div>
      {!splitReady && (
        <Alert kind="warn" style={{ marginBottom: 10 }}>
          No Train / Test Split step found upstream — this will fit using all rows. If the result feeds a model, add a Train / Test Split step first to avoid data leakage.
        </Alert>
      )}
      <MultiColsDropdown selected={sel} onChange={(v) => u({ columns: v, column: v[0] || null })} categorical />
      <OutputColumnNamesField
        columns={sel}
        value={c.output_columns}
        onChange={(v) => u({ output_columns: v })}
        legacyValue={c.output_column}
        autoName={(col) => `${col}_frequency_encoded`}
      />
      <DecimalPlacesField value={c.output_decimals} onChange={(v) => u({ output_decimals: v })} />
    </div>
  );
}
